import React from 'react';
import '../HEBREW/AcademySolutionsOffer.css';

const fitItems = [
    'עסקים שצריכים לחזק יכולות טכנולוגיות בתוך הארגון.',
    'חברות שרוצות לקצר onboarding ולשפר קליטת עובדים.',
    'ארגונים שצריכים הכשרות מעשיות ולא תוכן כללי.',
    'עסקים שרוצים לשפר עבודה עם מערכות, כלים ותהליכים.',
    'חברות שצריכות סדנאות, מסלולי הכשרה או תוכניות למידה מותאמות.',
    'ארגונים בינוניים שרוצים לבנות למידה פנימית בצורה מסודרת.'
];

const problemItems = [
    'הידע בתוך הארגון לא אחיד בין עובדים או צוותים.',
    'onboarding לוקח יותר מדי זמן ונשען על אנשים ספציפיים.',
    'יש תלות גבוהה באנשים בודדים שמחזיקים ידע קריטי.',
    'העובדים לא משתמשים במערכות או בכלים בצורה מלאה ונכונה.',
    'ההכשרות הקיימות כלליות מדי ולא מחוברות לעבודה בפועל.',
    'טעויות חוזרות נובעות מחוסר הכשרה או הבנה חלקית.',
    'חסרה מסגרת למידה מסודרת בתוך הארגון.',
    'קשה להטמיע ידע חדש בקצב שהעסק צריך.'
];

const audienceSignals = [
    'אם אתם צריכים שהצוות ילמד מהר יותר ויעבוד נכון יותר.',
    'אם onboarding אצלכם ארוך, לא אחיד או תלוי באנשים ספציפיים.',
    'אם אתם רוצים לפתח יכולות פנימיות במקום להישען תמיד על גורמים חיצוניים.',
    'אם אתם צריכים הכשרות מעשיות שמחוברות לתהליכים, לכלים ולמערכות שלכם.',
    'אם אתם רוצים להפוך למידה בתוך הארגון למשהו מסודר, מדיד ושימושי.'
];

const processSteps = [
    {
        number: '01',
        title: 'שיחת היכרות והבנת הפערים',
        text: 'ממפים את הצוותים, תחומי הידע, תהליכי העבודה והאתגרים שמצריכים חיזוק.'
    },
    {
        number: '02',
        title: 'מיפוי מטרות הלמידה',
        text: 'מגדירים מה צריך ללמד, למי, באיזה עומק, ואיך לחבר את הלמידה לעבודה האמיתית.'
    },
    {
        number: '03',
        title: 'בניית מסלול הכשרה ברור',
        text: 'בונים תוכנית מותאמת שיכולה לכלול סדנאות, תכנים, onboarding או תהליך למידה מתמשך.'
    },
    {
        number: '04',
        title: 'הטמעה, הדרכה ושיפור',
        text: 'מלווים את היישום, מעדכנים את המסלול לפי הצורך, ועוזרים להפוך ידע ליכולת מעשית.'
    }
];

const trustPoints = [
    'ניסיון מעשי בפיתוח, תשתיות, ענן ואבטחה.',
    'גישה פרקטית ולא תאורטית בלבד.',
    'הכשרות שמחוברות לעבודה אמיתית ולמערכות פעילות.',
    'מיקוד בשיפור יכולת, לא רק בהעברת ידע.'
];

const bookingUrl = 'https://meetings.hubspot.com/viacheslav-seifer';

const AcademySolutionsOffer = () => {
    const scrollToForm = () => {
        const formElement = document.getElementById('epic-academy-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <section className="academy-solutions-offer">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 text-center">
                        <h2 className="offer-title">הכשרות טכנולוגיות לעסקים שצריכים צוות חזק יותר, לא רק עוד חומר לימוד</h2>
                        <p className="lead offer-description">
                            אנחנו עוזרים לארגונים לבנות יכולות פנימיות דרך הכשרות ממוקדות, סדנאות מעשיות
                            ותוכניות למידה שמחוברות לעבודה האמיתית של הצוותים.
                        </p>
                        <div className="academy-cta-row">
                            <button
                                type="button"
                                className="btn btn-primary btn-lg cta-btn"
                                onClick={scrollToForm}
                            >
                                השאירו פרטים
                            </button>
                            <a
                                href={bookingUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-primary btn-lg cta-btn"
                            >
                                קבעו שיחת ייעוץ
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למי זה מתאים</h3>
                            <div className="bullet-grid">
                                {fitItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">האם זה נשמע מוכר?</h3>
                            <div className="bullet-grid">
                                {problemItems.map((item) => (
                                    <div key={item} className="bullet-card">
                                        <span className="bullet-icon">•</span>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center academy-main-section">
                    <div className="col-md-6">
                        <h3>הכשרה טובה לא נגמרת במצגת</h3>
                        <p>
                            המטרה היא לא רק להעביר חומר, אלא לעזור לצוות לעבוד נכון יותר, לקצר זמן כניסה לתפקיד,
                            ולבנות ביטחון מקצועי שאפשר לראות בביצוע בפועל.
                        </p>
                        <p>
                            כשהארגון גדל, העברת ידע לא פורמלית כבר לא מספיקה. צריך למידה מסודרת,
                            מחוברת למערכות, לכלים ולצורת העבודה האמיתית של הצוותים.
                        </p>
                        <div className="signal-list">
                            {audienceSignals.map((item) => (
                                <div key={item} className="signal-item">{item}</div>
                            ))}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="academy-image-placeholder academy-image-placeholder--first" aria-hidden="true" />
                    </div>
                </div>

                <div className="row align-items-center academy-secondary-section">
                    <div className="col-md-6">
                        <div className="academy-image-placeholder academy-image-placeholder--second" aria-hidden="true" />
                    </div>
                    <div className="col-md-6">
                        <h3>איך אנחנו עוזרים</h3>
                        <p>
                            אנחנו בונים תוכניות הכשרה מעשיות, סדנאות hands-on, מסלולי onboarding,
                            תכני on-demand ומבני למידה שמותאמים לצוותים, לתפקידים ולמערכות שלכם.
                        </p>
                        <p>
                            העבודה שלנו מחברת בין למידה, תפעול וביצוע, כדי שהכשרה תתרגם ליכולת אמיתית
                            ולא תישאר רק בתור תוכן שנצפה פעם אחת.
                        </p>
                        <div className="signal-list">
                            <div className="signal-item">סדנאות מעשיות והכשרות ממוקדות לצוותים טכנולוגיים ועסקיים.</div>
                            <div className="signal-item">מסלולי onboarding והעברת ידע לעובדים חדשים.</div>
                            <div className="signal-item">תוכניות upskilling סביב פיתוח, תשתיות, ענן, אבטחה ומערכות פנימיות.</div>
                            <div className="signal-item">תכנון למידה ארגונית ותמיכה בהטמעת LMS לפי הצורך.</div>
                            <div className="signal-item">בניית תהליך למידה שאפשר להמשיך ולשפר לאורך זמן.</div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">מה יוצא לכם מזה</h3>
                            <div className="trust-grid">
                                <div className="trust-item">צוות חזק ומסוגל יותר עם סטנדרט מקצועי עקבי.</div>
                                <div className="trust-item">onboarding מהיר ויעיל יותר לעובדים חדשים.</div>
                                <div className="trust-item">פחות תלות באנשים בודדים שמחזיקים ידע קריטי.</div>
                                <div className="trust-item">שימוש טוב יותר במערכות, בכלים ובתהליכים.</div>
                                <div className="trust-item">יותר ביטחון, עצמאות ויכולת ביצוע בתוך הצוותים.</div>
                                <div className="trust-item">למידה שמחוברת לצמיחה ולצרכים האמיתיים של הארגון.</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">איך זה עובד</h3>
                            <div className="process-grid">
                                {processSteps.map((step) => (
                                    <div key={step.number} className="process-card">
                                        <span className="process-number">{step.number}</span>
                                        <h4>{step.title}</h4>
                                        <p>{step.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row info-block">
                    <div className="col-lg-10 mx-auto">
                        <div className="section-card">
                            <h3 className="section-title">למה לעבוד איתנו</h3>
                            <div className="trust-grid">
                                {trustPoints.map((item) => (
                                    <div key={item} className="trust-item">{item}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <div className="final-cta-card">
                            <h3>אם אתם רוצים שהלמידה בארגון תייצר תוצאה אמיתית, זה הזמן לעשות סדר</h3>
                            <p className="lead">
                                בואו נבין מה צריך ללמד, לחזק ולהטמיע כדי לבנות יכולת פנימית חזקה יותר,
                                לקצר onboarding, ולהפוך ידע לביצוע עקבי.
                            </p>
                            <div className="academy-cta-row">
                                <button
                                    type="button"
                                    className="btn btn-light btn-lg cta-btn"
                                    onClick={scrollToForm}
                                >
                                    השאירו פרטים
                                </button>
                                <a
                                    href={bookingUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-light btn-lg cta-btn"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                            <p className="cta-note">שיחה ראשונית ללא התחייבות. חזרה תוך 24 שעות.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AcademySolutionsOffer;
